import type { Resource } from '../../';
export const search_box_frame_productsBySearch: Resource = {"default":"Products"};
